const DECLINE_STORAGE_KEY = 'shippingProtectionDeclined';

class CartShippingProtection extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.cart-shipping-protection__input');
    this.variantId = this.dataset.variantId;

    if (!this.input || !this.variantId) return;

    this.input.addEventListener('change', this.onToggle.bind(this));

    this.maybeAutoAdd();
  }

  maybeAutoAdd() {
    const alreadyInCart = this.dataset.inCart === 'true';
    const cartIsEmpty = this.dataset.cartEmpty === 'true';
    const previouslyDeclined = window.localStorage.getItem(DECLINE_STORAGE_KEY) === 'true';

    // Default-on: silently include protection once there's a real order to
    // attach it to, unless the customer has turned it off before.
    if (!alreadyInCart && !cartIsEmpty && !previouslyDeclined) {
      this.addProtection().then(() => this.refreshCartDrawer());
    }
  }

  async onToggle(event) {
    const adding = event.target.checked;
    this.input.disabled = true;

    try {
      if (adding) {
        await this.addProtection();
        window.localStorage.removeItem(DECLINE_STORAGE_KEY);
      } else {
        await this.removeProtection();
        window.localStorage.setItem(DECLINE_STORAGE_KEY, 'true');
      }

      await this.refreshCartDrawer();
    } catch (error) {
      console.error('Cart shipping protection update failed:', error);
      event.target.checked = !adding;
    } finally {
      this.input.disabled = false;
    }
  }

  addProtection() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: this.variantId, quantity: 1 }],
      }),
    });
  }

  removeProtection() {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.variantId, quantity: 0 }),
    });
  }

  async refreshCartDrawer() {
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer-section`);
    const data = await response.json();
    const html = data['cart-drawer-section'];

    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Only swap the content INSIDE the open <dialog>, never the dialog element
    // itself — replacing the dialog resets its open state and looks like the
    // drawer closed on you.
    const newInner = doc.querySelector('.cart-drawer__inner');
    const currentInner = document.querySelector('.cart-drawer__inner');

    if (newInner && currentInner) {
      currentInner.innerHTML = newInner.innerHTML;
    }

    // Let any theme-level cart listeners (item count bubble, etc.) know the cart changed.
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  }
}

customElements.define('cart-shipping-protection', CartShippingProtection);